import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const Footer = ({ tone = 'auto', className = '' }) => {
  return null;
};

export default Footer;